import React, {useState} from 'react';
import {Field, withFormik} from "formik";
import Button from "@material-ui/core/Button";
import * as Yup from "yup";
import {connect} from "react-redux";
import MaterialTextField from "../../../comun/Forms/MaterialTextField";
import {Grid} from "../../../comun/Grid/Grid";
import {AutocompleteUser} from "../../../comun/AutocompleteUser/AutocompleteUser";
import {filterCities} from "../../City/CityAction";
import {filterZones} from "../../Zone/ZoneAction";


export let StandFilters = ({stand, handleSubmit, manage=false, ...props}) => {
    
    return(
        <React.Fragment>
            <form className="form-filters" onSubmit={handleSubmit}>
                <h3>Filtros</h3>
                <Grid columns="1fr 1fr" mobileColumns="1fr">
                    <Field className="form-filters-text" size="small" component={MaterialTextField} name="mall"
                           variant="outlined" label="Nombre Centro Comercial" />
                    
                    <Field className="form-filters-text" size="small" component={MaterialTextField} name="code"
                           variant="outlined" label="Código" />

                    <Field name="city"
                           label="Ciudad"
                           labelAttr="name"
                           component={AutocompleteUser}
                           load={filterCities}
                           loadParams={() => {
                               return {cleaned: true}
                           }}
                           variant="outlined"
                           className="form-control" />

                    <Field name="zone"
                           label="Zona"
                           labelAttr="name"
                           component={AutocompleteUser}
                           load={filterZones}
                           loadParams={() => {
                               return {cleaned: true}
                           }}
                           variant="outlined"
                           className="form-control" />

                    <Button  variant="contained" className="form-control-child-input-height" color="secondary" type="submit">Filtrar</Button>
                </Grid>

            </form>
        </React.Fragment>
    )
}

const schema = Yup.object().shape({
    mall: Yup.string(),
    code: Yup.string(),
    city: Yup.object().nullable(),
    zone: Yup.object().nullable()

});

StandFilters = withFormik(
    {
        validationSchema: schema,
        mapPropsToValues: (props) => {
            return {
                mall: '',code: '',city: {id: 0, name: 'Ninguno'},zone: {id: 0, name:'Ninguno'}
            }
        },
        handleSubmit: async (vals, props) => {
            const data = Object.assign({}, vals);

            console.log(data.city);

            if (data.city) {
                if (data.city.id > 0) {
                    data.city = data.city.id;
                } else {
                    data.city = null;
                }
            }

            if (data.zone) {
                if (data.zone.id > 0) {
                    data.zone = data.zone.id;
                } else {
                    data.zone = null;
                }
            }

            props.setSubmitting(false);
            props.props.onSubmit(data);
        },
        displayName: 'Filtrar Stands',
    }
)(StandFilters);
const mapPropsToState = state => {
    return {
        stand: state.stand
    }
}

StandFilters = connect(mapPropsToState, null)(StandFilters);
